/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'play': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M3.5 3.334v13.381l13.382-6.244L3.5 3.334zm-1-.5a.7.7 0 011.03-.618l14.352 7.655a.7.7 0 01-.033 1.252L3.496 17.82a.7.7 0 01-.996-.635V2.834z" _fill="#1F222C"/>'
  }
})
